import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
    let host = import.meta.env.VITE_HOST;
    let port = import.meta.env.VITE_PORT;

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // Stato per gestire la visibilità della password
    const [rememberMe, setRememberMe] = useState(false); // Stato per "Ricordati di me"
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(host + ":" + port + "/api/v1/auth/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    accept: "application/json",
                },
                body: JSON.stringify({ email, password, rememberMe }),
            });

            const data = await response.json();

            if (response.ok) {
                const { id, jwt_token, is_admin } = data;
                localStorage.setItem("jwt_token", jwt_token);
                localStorage.setItem("user_id", id);

                if (is_admin === true) {
                    localStorage.setItem("admin", "1");
                    window.location.href = "/admin-dashboard";
                } else {
                    window.location.href = "/";
                }
            } else {
                setError(data.message || "Credenziali errate");
            }
        } catch (err) {
            setError("Errore di connessione");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center bg-[#fbfef5] lg:pt-50 pt-10">
            <div className="w-full max-w-lg p-6 space-y-8"> {/* Cambiato max-w-xl a max-w-lg */}
                <h1 className="titolo-style mb-8 text-center">
                    <span
                        className="block text-[#94c41c]"
                        style={{
                            marginBottom: '0px',
                            display: 'block',
                            fontSize: '55px',
                            lineHeight: '1.2',
                        }}
                    >
                        Bentornato
                    </span>
                </h1>
                <p className="text-gray-600 mb-8 text-2xl">
                    Bentornato su Seeurl, il tuo mondo di domini ti aspetta
                </p>

                {error && <div className="text-red-500 text-xl mb-6">{error}</div>}

                <form onSubmit={handleSubmit} className="space-y-8">
                    {/* Campo Email */}
                    <div className="form-group">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-8 py-4 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                            placeholder="Indirizzo email"
                            required
                        />
                    </div>

                    {/* Campo Password */}
                    <div className="form-group relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-8 py-4 border-2 border-[#94c41c] rounded-md focus:outline-none focus:ring-2 focus:ring-[#94c41c] text-xl text-black"
                            placeholder="La tua password"
                            required
                        />
                        <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute top-1/2 right-4 text-[#94c41c] transform -translate-y-1/2 text-xl"
                        >
                            <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                        </button>
                    </div>

                    {/* Checkbox "Ricordati di me" */}
                    <div className="flex justify-center items-center space-x-4 text-xl">
                        <input
                            type="checkbox"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            className="h-4 w-4 text-[#94c41c] border-[#94c41c] rounded"
                        />
                        <label htmlFor="rememberMe" className="text-xl text-gray-600">
                            Ricordati di me
                        </label>
                    </div>

                    {/* Pulsante di Login */}
                    <div>
                        <button
                            type="submit"
                            className="w-full bg-[#94c41c] text-white py-4 px-8 rounded-full hover:bg-black transition-all duration-300 border-2 border-[#4a8e44] text-xl"
                            disabled={isLoading}
                            style={{ fontSize: '20px' }}
                        >
                            {isLoading ? "Caricamento..." : "Login"}
                        </button>
                    </div>

                    {/* Pulsante di Registrazione */}
                    <div className="text-center mt-4">
                        <button
                            onClick={() => navigate("/register")}
                            className="w-full bg-[#627f15] text-white py-4 px-8 rounded-full hover:bg-black transition-all duration-300 border-2 border-[#4a8e44] text-xl"
                            style={{fontSize: '20px'}}
                        >
                        Registrati
                        </button>
                    </div>

                    {/* Recupero password */}
                    <div className="text-center mt-4">
                        <span style={{ fontSize: '20px', color: 'black' }}>Non ricordi la password? </span>
                        <a
                            href="/forgot-password"
                            className="text-xl text-[#94c41c] underline"
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            Clicca qui
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
